module.exports = __webpack_public_path__ + "static/Wallnuss-9493628871ed4226180b73e8ec46ddeb.png";